export default __webpack_public_path__ + "static/media/not_allowed.5c01ce36.svg";